import React from "react";
import styled from "styled-components";
import { EndingBadge, NewBadge, PopularBadge } from "../../assets";

const Badge = styled.div`
  position: absolute;
  top: 12px;
  left: -6px;
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const BadgeIcon = ({ badgeType, width, height }) => {
  const type = badgeType?.toLowerCase();
  switch (type) {
    case "popular":
      return <img src={PopularBadge} alt="Popular" width={width} height={height} />;

    case "ending":
      return <img src={EndingBadge} alt="Ending" width={width} height={height} />;

    case "new":
         return <img src={NewBadge} alt="New" width={width} height={height} />;
    default:
      return "";
  }
};

const BadgeWrapper = ({ badgeType, width, height }) => {
  return (
    <Badge width={width} height={height}>
      <BadgeIcon badgeType={badgeType} width={width} height={height} />
    </Badge>
  );
};

export default BadgeWrapper;
